// Panel-local state (collapsed flag) exposed as a React context so
// AgentPanelHeader can flip it without the parent having to prop-drill
// through <AgentPanelContext> and <AgentPanelChat>. The file is named
// agentPanelState.ts rather than AgentPanelContext.ts to avoid a
// name collision with the AgentPanelContext component (the "context
// pane") that will carry the ambient surface context in M7.2.

import { createContext, useContext } from 'react';

export type AgentPanelState = {
  collapsed: boolean;
  toggleCollapsed: () => void;
};

export const AgentPanelStateContext = createContext<AgentPanelState | null>(null);

export function useAgentPanelState(): AgentPanelState {
  const ctx = useContext(AgentPanelStateContext);
  if (!ctx) {
    throw new Error('useAgentPanelState must be used inside <AgentPanel>');
  }
  return ctx;
}

// Collapsed preference is per operator AND per brand. A brand-only
// key (`reach-social.agent-panel.collapsed.<brandId>`) would leak
// one operator's rail state to anyone else using the same browser
// profile on that brand. Missing either id → no persistence.
export function collapsedStorageKey(
  operatorId: string | null | undefined,
  brandId: string | null | undefined
): string | null {
  if (!operatorId || !brandId) return null;
  return `reach-social.agent-panel.collapsed.${operatorId}.${brandId}`;
}
